import Vue from 'vue'
import Router from 'vue-router'

const PageRouter = () => import('@/page-lib/components/PageRouter')

Vue.use(Router)

export default new Router({
  mode: process.env.VUE_APP_VUE_ROUTER_MODE, // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      name: 'PageRouterRoot',
      component: PageRouter,
    },
  ]
}

